import { Link, useLocation } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem } from "reactstrap";
import CopyToClipboardButton from '../../components/CopyToClipboardButton';


const ReducedBreadcrumb = (props) => {
    let location = useLocation();
    let str = location.pathname;
    let arr = str.split("/");

    arr = arr.filter(e => e);

    return (

        <Breadcrumb>
            <BreadcrumbItem className="text">
                <Link to="/" >
                    <i className="bi bi-house-fill"></i>
                </Link>
            </BreadcrumbItem>
            {
                arr.map((path, index) => (
                    <BreadcrumbItem key={index} active={arr.slice(-1) === path ? true : false}>
                        {
                            !path.includes("view") ?
                                LinkOrSpan(path, arr, location, props.title) : <>-</>
                        }
                    </BreadcrumbItem>
                ))
            }
            <CopyToClipboardButton text={window.location.href} />
        </Breadcrumb>
    )

};

function LinkPath(path) {
    const location = useLocation();
    const pathSegments = location.pathname.split('/');
    const pathIndex = pathSegments.indexOf(path);

    // Construct fullPath only if path is found in the segments
    if (pathIndex !== -1) {
        const fullPath = '/' + pathSegments.slice(1, pathIndex + 1).join('/');
        return fullPath;
    }
}

function LinkOrSpan(path, arr, location, title) {
    let name = path
        .split('-')
        .map(part => part.charAt(0).toUpperCase() + part.substr(1))
        .join(' ');

    let fullPath = LinkPath(path);

    if (arr.slice(-1).includes(path)) {
        return (<span>{title}</span>)
    }
    else {
        return (
            <Link to={fullPath} >
                {name}
            </Link>
        )
    }

}

export default ReducedBreadcrumb;